import { action } from 'typesafe-actions';
import { ListaAuditoriaTypes } from './types';

interface AuditoriaSetings {
  pageNo: number;
  pageSize: number;
  identificationKey: number;
  ownershipType: number;
  dtInicio: string | undefined;
  dtFim: string | undefined;
  company: any;
}

export const getListaAuditoriaRequest = (AuditoriaSetings: AuditoriaSetings) =>
  action(ListaAuditoriaTypes.GET_LISTA_AUDITORIA_RESQUEST, {
    AuditoriaSetings,
  });

export const getListaAuditoriaSuccess = (data: any) =>
  action(ListaAuditoriaTypes.GET_LISTA_AUDITORIA_SUCCESS, { data });

export const getListaAuditoriaFailure = () =>
  action(ListaAuditoriaTypes.GET_LISTA_AUDITORIA_FAILURE, {});

export const cleanListaAuditoria = () =>
  action(ListaAuditoriaTypes.CLEAN_LIST_AUDITORIA, {});
